import { HardDrive, Clock, MonitorSmartphone, Network, ShieldCheck, LayoutGrid } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const NvrRecorder = () => {
  const features = [
    {
      Icon: HardDrive,
      title: '大容量録画に対応',
      desc: '複数HDD搭載モデルにより、長期間の映像保存が可能です。カメラ台数・保存日数に合わせて容量を選定します。',
    },
    {
      Icon: LayoutGrid,
      title: '多台数のカメラ管理',
      desc: '4ch / 8ch / 16ch / 32chなど、施設規模に合わせたモデルがあります。',
    },
    {
      Icon: MonitorSmartphone,
      title: '遠隔監視・スマホ確認',
      desc: 'アプリやブラウザから、外出先での映像確認・録画再生に対応します。',
    },
    {
      Icon: Network,
      title: 'IPカメラとの一括管理',
      desc: 'HS-IEシリーズ、HS-IBシリーズなど、IPカメラを統合管理できます。',
    },
    {
      Icon: Clock,
      title: '検索・再生機能',
      desc: '日時・イベント・チャンネル別に映像を検索・再生できます。',
    },
    {
      Icon: ShieldCheck,
      title: 'RAID対応モデル',
      desc: '映像の冗長性を高めたい大規模施設向けにRAID対応モデルもあります。',
    },
  ];

  const notes = [
    '録画日数は、カメラ台数・解像度・録画方式(常時/動体)・HDD容量により大きく変わります。',
    '停電時のUPS(無停電電源)、ネットワーク遮断時の対策など、運用面での事前確認が必要です。',
    'クラウド録画やバックアップ運用と組み合わせる場合はご相談ください。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="nvr"
      eyebrow="RECORDER"
      name="NVR・録画機器"
      description="カメラ台数、録画日数、保存容量、遠隔確認の有無に合わせて録画機器を選定します。店舗から大規模施設まで幅広い構成に対応します。"
      tags={['NVR', '4ch / 8ch / 16ch / 32ch', 'RAID対応モデル', '遠隔確認', 'アプリ対応']}
      features={features}
      locations={['店舗・商業施設', 'オフィス', '工場・倉庫', 'マンション・集合住宅', '駐車場', '公共施設', '施設全般']}
      notes={notes}
    />
  );
};

export default NvrRecorder;
